import { configureStore } from '@reduxjs/toolkit'
import { salePageApi } from './services/salePageApi'
import { digitalAppApi } from './services/digitalAppApi'
import { dropletOrderApi } from './services/dropletOrderApi'

import allItemsSlice from './slices/allItems'
import allItemsCartSlice from './slices/allItemsCart'
import allItemsFavoritesSlice from './slices/allItemsFavorites'
import searchSlice from './slices/search'
import createOrderData from './slices/createOrderData'
import accountData from './slices/accountData'
import filterData from './slices/filterData'
import accModal from './slices/accModal'
import contextUI from './slices/contextUI'
import itemsCartSlice from './slices/itemsCart'
import teplateOrderSlice from './slices/templateOrder'
import saleCartSlice from './slices/saleCart'
import { localStorageMiddleware } from './middlewares/localStorageMiddleware'

const combineReducers = {
  search: searchSlice,
  allItems: allItemsSlice,
  allItemsCart: allItemsCartSlice,
  allItemsFavorites: allItemsFavoritesSlice,
  createOrderData: createOrderData,
  accountData: accountData,
  filterData: filterData,
  accModal: accModal,
  contextUI: contextUI,
  itemsCart: itemsCartSlice,
  teplateOrder: teplateOrderSlice,
  saleCart: saleCartSlice,
  [salePageApi.reducerPath]: salePageApi.reducer,
  [digitalAppApi.reducerPath]: digitalAppApi.reducer,
  [dropletOrderApi.reducerPath]: dropletOrderApi.reducer,
}

export const store = configureStore({
  reducer: combineReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // PDF Blob responses in RTK Query cache (print-document endpoints)
        ignoredPaths: [
          /^digitalAppApi\.queries\.getAlbaranById/,
          /^digitalAppApi\.queries\.getCheckListById/,
          /^digitalAppApi\.queries\.getInvoiceById/,
          /^digitalAppApi\.queries\.getInvoiceDetailed/,
        ],
        ignoredActionPaths: ['meta.baseQueryMeta'],
      },
    }).concat(
      salePageApi.middleware,
      digitalAppApi.middleware,
      dropletOrderApi.middleware,
      localStorageMiddleware,
    ),
})
